<template>
  <div class="things-box d-flex">
    <div class="df-group country-list">
      <select :disabled="cityLoading" v-model="cityCountry">
        <option v-for="c in hotelCountry" :value="c">{{ cleanCountry(countryList[c.toLowerCase()].name) }}</option>
        <!-- <option v-for="c in hotelCountry" :value="c">{{ c.toLowerCase() }}</option> -->
      </select>
    </div>
    <div :class="['df-group', {active: !location}]">
      <location-input :value="location" :extra="locationExtra" ref="location"
        :error="validation.location" leg="leg1" :disabled="hotel.location.loading || cityLoading"
        @change="locationNewValue" @submit="triggerClickSubmit" :loading="cityLoading"
      ></location-input>
    </div>
    <div class="df-group">
      <input type="text" v-model="dateLoc" @click="showDate" class="txt-field" readonly />
    </div>
    <a @click="showTravellerModal" ref="quoteBtn" class="lr-btn">Search</a>

    <date-modal :startDate="hotel.date.start" :endDate="hotel.date.end" @newDate="newDate" />
    <travellers-modal ref="travModal" @submit="submit"></travellers-modal>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import LocationInput from '../LocationInput'
import DateModal from './DateTimePicker'
import TravellersModal from './TravellersModal'

const countries = require('@/data/countries')

export default {
  name: 'sight-seeing-form',
  components: { LocationInput, DateModal, TravellersModal },
  data () {
    return {
      location: '',
      locationExtra: {
        field: 'hotel',
        placeholder: 'Going to',
        type: 'location'
      },
      dateLoc: '',
      validation: {
        location: ''
      },
      hotelCountry: ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', /* 'AN', */ 'AO', /* 'AQ', */ 'AR', 'AS', 'AT', 'AU', 'AW', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', /* 'EU', */ 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GT', 'GU', 'GW', 'GY', 'HK', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IN', 'IQ', 'IR', 'IS', 'IT', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TG', 'TH', 'TJ', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', /* 'XO', */ 'YE', 'YT', /* 'YU', */ 'ZA', 'ZM', 'ZW'],
      countryList: countries,
      cityLoading: false
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    travellers () { return this.filters.travellers },
    user () { return this.$store.state.user },
    hotel () { return this.$store.state.hotel },
    locations () { return this.hotel.location },
    city () { return this.hotel.city },
    _cityCountry () { return this.hotel.country },
    cityCountry: {
      get () { return this.hotel.country },
      set (x) {
        this.location = ''
        this.$store.commit('hotel/setData', {country: x})
      }
    }
  },
  methods: {
    locationNewValue (x) {
      if (x.keyInput && x.check) {
        this.validation.location = ''
        this.location = x.keyInput
        this.showDate()
      }
    },
    triggerClickSubmit () {
      this.submit()
    },
    showDate () {
      this.$store.commit('hotel/setDateData', {show: true})
    },
    newDate (x) {
      this.$store.commit('hotel/setDateData', x)
      this.updateDate()
      // this.submit()
      if (this.$refs.travModal) this.$refs.travModal.toggleModal(true)
    },
    showTravellerModal () {
      if (this.$refs.travModal) this.$refs.travModal.toggleModal(true)
    },
    updateDate () {
      // this.dateLoc = `${this.things.date.start} - ${this.things.date.end}`
      let start = ''
      let end = ''
      let NoOfNights = 1
      if (this.hotel.date.start) {
        start = moment(this.hotel.date.start, 'MM/DD/YYYY')
        end = moment(this.hotel.date.end, 'MM/DD/YYYY')
        NoOfNights = end.diff(start, 'days')
      }
      this.dateLoc = `${this.hotel.date.start} - ${NoOfNights} ${NoOfNights === 1 ? 'day' : 'days'}`
    },
    submit () {
      let self = this
      self.validation.location = ''
      if (!self.location) {
        self.validation.location = 'This field cannot be empty.'
        return
      }
      self.$store.commit('global/setLoaderData', {show: true})
      let startDate = moment(self.hotel.date.start, 'MM/DD/YYYY')
      let endDate = moment(self.hotel.date.end, 'MM/DD/YYYY')

      let NoOfNights = 1
      if (startDate !== endDate) NoOfNights = endDate.diff(startDate, 'days')
      startDate = startDate.format('DD-MM-YYYY')
      endDate = endDate.format('DD-MM-YYYY')

      let roomGuests = self.buildRooms(self.travellers.adult, self.travellers.children, self.hotel.childAge)

      self.$sdk.post2(`${CONFIG.d2dAPI}/hotel/search`, {
        CheckInDate: startDate,
        CityId: self.locations.selected.origin,
        // CityId: 6743,
        NoOfNights: NoOfNights,
        NoOfRooms: self.hotel.roomCount,
        hotel_version: 'tripjack',
        // GuestNationality: self.locations.selected.countryCode,
        GuestNationality: 'IN',
        RoomGuests: roomGuests.rooms
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.success || r.error || (r.data && Object.hasOwn(r.data, 'Status') && !r.data.Status)) {
          let msg = r.message
          if (r.error && r.error.message) msg = r.error.message
          if (r.data && !r.data.Status) msg = r.data.Message
          self.$store.commit('global/setAlertData', {
            show: true,
            message: msg
          })
          return
        }

        self.$store.commit('hotel/setData', {
          list: r.data.HotelSearchResult.HotelResults
        })
        self.$store.commit('reservation/setOtherData', {bookingType: 'hotel'})
        self.$router.push('hotel')
      })
    },
    buildRooms (adultCount, childCount, childAges) {
      // Validate inputs
      adultCount = Math.max(1, Math.min(10, Math.floor(adultCount)))
      childCount = Math.max(0, Math.min(10, Math.floor(childCount)))

      // Ensure childAges matches childCount
      childAges = childAges.slice(0, childCount);
      // If not enough ages provided, fill with 0
      while (childAges.length < childCount) {
        childAges.push(0);
      }

      const rooms = []
      const totalRooms = Math.ceil(adultCount / 2) // Each room holds max 2 adults

      // Distribute adults first (max 2 per room)
      let remainingAdults = adultCount
      for (let i = 0; i < totalRooms; i++) {
        const adultsInRoom = Math.min(2, remainingAdults)
        remainingAdults -= adultsInRoom
        rooms.push({
          // roomIndex: i,
          NoOfAdults: adultsInRoom,
          NoOfChild: 0,
          ChildAge: []
        })
      }

      // Distribute children as evenly as possible across rooms
      if (childCount > 0 && totalRooms > 0) {
        const baseChildrenPerRoom = Math.floor(childCount / totalRooms);
        const extraChildren = childCount % totalRooms;

        let childIndex = 0;
        for (let i = 0; i < totalRooms; i++) {
          const childrenInRoom = baseChildrenPerRoom + (i < extraChildren ? 1 : 0);
          rooms[i].NoOfChild = childrenInRoom;
          // Assign ages to this room
          rooms[i].ChildAge = childAges.slice(childIndex, childIndex + childrenInRoom);
          childIndex += childrenInRoom;
        }
      }

      return {
        totalRooms: rooms.length,
        totalAdults: adultCount,
        totalChildren: childCount,
        rooms: rooms
      }
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          if (this.user.title) tmpObj.title0 = this.user.title
          if (this.user.gender) {
            tmpObj.gender0 = this.user.gender
            if (this.user.gender === 'Male') tmpObj.gender0 = 1
            if (this.user.gender === 'Female') tmpObj.gender0 = 2
          }
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
    },
    cleanCountry (x) {
      return x.replace(/\s*\([^)]*\)/g, '')
    },
    getCity () {
      let self = this
      if (self.hotel.country === self.city.country) return

      self.cityLoading = true
      let country = JSON.parse(JSON.stringify(self.hotel.country))
      self.$sdk.get2(`${CONFIG.d2dAPI}/hotels/country/${country}`, {}, r => {
        self.cityLoading = false
        let cities = []
        if (r.success && r.data.length) {
          r.data = r.data.map(({ cityName, ...rest }) => ({ destinationName: cityName, destinationCode: cityName, ...rest }))
          cities = r.data.filter(c => c.regionType === 'MULTI_CITY_VICINITY')
          // cities = cities
        }
        self.$store.commit('hotel/setCityData', {
          country: country,
          list: cities
        })
      })
    }
  },
  watch: {
    _cityCountry () {
      this.getCity()
    }
  },
  mounted () {
    if (this.hotel.location.selected && this.hotel.location.selected.destinationName) this.location = `${this.hotel.location.selected.destinationName}, ${this.hotel.location.selected.countryName}`
    if (!this.hotel.date.start) {
      this.$store.commit('hotel/setDateData', {
        start: moment().add(3, 'days').format('MM/DD/YYYY'),
        // end: ''
        end: moment().add(10, 'days').format('MM/DD/YYYY')
      })
    }
    this.updateDate()
    this.getCity()
  }
}
</script>

<style lang="scss" scoped>
.things-box{
  gap: 10px;
  padding: 10px;
}
.df-group{
  width: 100%;
  &.country-list{
    max-width: 200px;

    select{
      outline: none;
      padding: 10px;

      &:disabled{
        background: #fafafa;
      }
    }
  }
  &.active{
    outline: 2px solid #ff9c09;
  }
}
.txt-field{
  margin: 0;
  color: #333;
  width: 100%;
  position: relative;
  z-index: 1;
  box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
  outline: none;
  background: #fbfbfb;
  border: 1px solid #ccc;
  height: 40.4px;
  border-radius: 0;
  padding: 10px;
}

@media only screen and (max-width: 641px) {
  .things-box{
    flex-direction: column;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?469faa55